import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhatsappApisRoutingModule } from './whatsapp-apis-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    WhatsappApisRoutingModule
  ]
})
export class WhatsappApisModule { }
